import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  GetUser: null,
  Token: null,
};

export const userSlice = createSlice({
  name: 'userAuth',
  initialState,
  reducers: {
    // userSignUp: (state, action) => {
    //   state.GetUser = action.payload.GetUser;
    //   state.Token = action.payload.Token;
    // },
    userLogIn: (state, action) => {
      state.GetUser = action.payload.GetUser;
      state.Token = action.payload.Token;
    },
    userLogout: (state) => {
      state.GetUser = null;
      state.Token = null;
    },
  },
});

export const { userLogIn, userLogout } = userSlice.actions;

export default userSlice.reducer;
